import _defineProperty from "@babel/runtime/helpers/defineProperty";
import _toConsumableArray from "@babel/runtime/helpers/toConsumableArray";
import _slicedToArray from "@babel/runtime/helpers/slicedToArray";
function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }
import React, { forwardRef, useEffect, useImperativeHandle, useRef } from 'react';
import { UploadCardGroup } from './UploadCard';
import { MaterialDialog } from './MaterialDialog';
import { useDialogState } from './hooks';
import { CropSizeDialog } from './CropSizeDialog';
import { UploadStatusModal } from './UploadStatusModal';
import { ImageStatus, startUrlUpload } from './utils';
import { getImageNaturalCroppedArea } from '../MaterialUpload/hooks/useImageUpload';
export var MultipleImageUpload = forwardRef(function (props, ref) {
  var count = props.count,
    value = props.value,
    apiConfig = props.apiConfig,
    cropSizeConfig = props.cropSizeConfig,
    _props$uploadDialogOp = props.uploadDialogOpts,
    uploadDialogOpts = _props$uploadDialogOp === void 0 ? {} : _props$uploadDialogOp,
    _props$selectedId = props.selectedId,
    selectedId = _props$selectedId === void 0 ? '' : _props$selectedId,
    _props$uploadButton = props.uploadButton,
    uploadButton = _props$uploadButton === void 0 ? null : _props$uploadButton,
    _props$checkCountBefo = props.checkCountBeforeUpload,
    checkCountBeforeUpload = _props$checkCountBefo === void 0 ? false : _props$checkCountBefo,
    onValueChange = props.onValueChange,
    onRemove = props.onRemove,
    onSelect = props.onSelect;
  var uploadRef = useRef();
  var _useDialogState = useDialogState(),
    _useDialogState2 = _slicedToArray(_useDialogState, 2),
    state = _useDialogState2[0],
    setDialogState = _useDialogState2[1];
  var imageListDialogVisible = state.imageListDialogVisible,
    cropDialogVisible = state.cropDialogVisible,
    uploadStatusModalStatus = state.uploadStatusModalStatus,
    selectedImages = state.selectedImages;
  useEffect(function () {
    setDialogState({
      selectedImages: _toConsumableArray(value)
    });
  }, [value]);
  useImperativeHandle(ref, function () {
    return {
      upload: function upload() {
        setDialogState({
          imageListDialogVisible: true
        });
      }
    };
  }, []);
  var uploadFiles = function uploadFiles(files) {
    uploadRef.current = 'uploading';
    setDialogState({
      cropDialogVisible: false,
      uploadStatusModalStatus: 'uploading'
    });
    var array = files.map(function (file) {
      var naturalCropArea = getImageNaturalCroppedArea({
        width: file.value.imageWidth,
        height: file.value.imageHeight
      });
      var cropArea = file.cropInfo || naturalCropArea;
      return startUrlUpload(apiConfig.uid, file.value, cropArea, {
        url: apiConfig.imageUpload.urlUpload.url,
        request: apiConfig.request
      });
    });
    Promise.all(array).then(function (res) {
      var successList = [];
      var failedList = [];
      var value = [];
      res.forEach(function (data) {
        value.push(data.data);
        if (data.status === ImageStatus.SUCCESS) {
          successList.push(data);
        }
        if (data.status === ImageStatus.ERROR) {
          failedList.push(data);
        }
      });
      if (uploadRef.current === 'abort') {
        return;
      }
      onValueChange(value);
      if (successList.length === res.length) {
        setDialogState({
          uploadStatusModalStatus: 'success'
        });
        return;
      }
      if (failedList.length === res.length) {
        setDialogState({
          uploadStatusModalStatus: 'failed'
        });
        return;
      }
      setDialogState({
        uploadStatusModalStatus: 'partialSuccess'
      });
      return;
    });
  };
  return React.createElement(React.Fragment, null, uploadButton, !uploadButton && React.createElement("div", null, React.createElement(UploadCardGroup, {
    selectedId: selectedId,
    count: count,
    value: value,
    onClick: function onClick() {
      return setDialogState({
        imageListDialogVisible: true
      });
    },
    onDelete: function onDelete(id) {
      var image = value === null || value === void 0 ? void 0 : value.find(function (item) {
        return item.materialId === id;
      });
      onRemove(image);
    },
    onSelect: onSelect,
    onRepeat: function onRepeat() {
      return setDialogState({
        imageListDialogVisible: true
      });
    }
  })), React.createElement(MaterialDialog, {
    checkCountBeforeUpload: checkCountBeforeUpload,
    value: selectedImages,
    visible: imageListDialogVisible,
    count: count,
    apiConfig: apiConfig,
    cropSizeConfig: cropSizeConfig,
    onValueChange: function onValueChange(value) {
      return setDialogState({
        selectedImages: value
      });
    },
    onOK: function onOK() {
      setDialogState({
        imageListDialogVisible: false,
        cropDialogVisible: true
      });
    },
    onCancel: function onCancel() {
      return setDialogState({
        imageListDialogVisible: false
      });
    }
  }), React.createElement(CropSizeDialog, {
    value: selectedImages,
    visible: cropDialogVisible,
    apiConfig: apiConfig,
    cropSizeConfig: cropSizeConfig,
    onOk: uploadFiles,
    onCancel: function onCancel() {
      return setDialogState({
        cropDialogVisible: false,
        imageListDialogVisible: true
      });
    }
  }), React.createElement(UploadStatusModal, _objectSpread({
    statusType: uploadStatusModalStatus,
    onClose: function onClose() {
      if (uploadStatusModalStatus === 'success') {
        setDialogState({
          uploadStatusModalStatus: 'hide'
        });
        return;
      }
      if (uploadStatusModalStatus === 'failed' || uploadStatusModalStatus === 'partialSuccess') {
        setDialogState({
          uploadStatusModalStatus: 'hide',
          imageListDialogVisible: true
        });
      }
      if (uploadStatusModalStatus === 'uploading') {
        uploadRef.current = 'abort';
        setDialogState({
          uploadStatusModalStatus: 'hide',
          imageListDialogVisible: true
        });
      }
    }
  }, uploadDialogOpts)));
});